import React from 'react'

import { string, bool, shape, arrayOf } from 'prop-types'

import { useActionsData } from 'Pods/UnifiedNavigation/Hooks/useActionsData'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import UserAction from './Components/UserAction/UserAction'
import UserMenu from './Components/UserMenu/UserMenu'

// Actions the redesigned bar surfaces; upload / boost-credits are no longer in the
// top navigation. Popovers (cart/inbox/notifications) are built in a later phase.
const VISIBLE_ACTION_IDS = ['cart-action', 'inbox-action', 'notifications-action']

function UserActions({ actionsLinks = EMPTY_ARRAY, actionsConfig = EMPTY_OBJECT, locale = 'en' }) {
  const { isCurrentUser = false } = actionsConfig
  const { cart, messages, notifications } = useActionsData(isCurrentUser)

  const countsMap = {
    'cart-action': cart.meta.size,
    'inbox-action': messages.totalUnreadMessages,
    'notifications-action': notifications.feedSize,
  }

  const visibleActions = actionsLinks.filter(({ id }) => VISIBLE_ACTION_IDS.includes(id))

  return (
    <div className="unified-nav__actions">
      <ul className="unified-nav__actions-list">
        {visibleActions.map(({ id, icon, isForUser }) => (
          <UserAction
            key={id}
            id={id}
            icon={icon}
            isForUser={isForUser}
            isCurrentUser={isCurrentUser}
            count={countsMap[id]}
          />
        ))}
      </ul>

      <UserMenu isCurrentUser={isCurrentUser} locale={locale} />
    </div>
  )
}

UserActions.propTypes = {
  actionsLinks: arrayOf(shape({
    id: string,
    href: string,
    icon: string,
    isForUser: bool,
  })),
  actionsConfig: shape({
    isCurrentUser: bool,
  }),
  locale: string,
}

export default UserActions
